import { UntitledIcon } from '@faceup/icons'
import { usAttachment01 } from '@faceup/icons/usAttachment01'
import { Button, Flex, Space } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { ucDropzone } from '../customIcons'
import { Form } from '../Form'
import { InputFake } from '../Input'
import { Dropzone, type DropzoneProps } from './Dropzone'

type ModifiedDropzoneProps = Omit<DropzoneProps, 'style' | 'children' | 'translations'>

type ChatDropzoneProps = {
  children: ReactNode
  suffix?: ReactNode
  prefix?: ReactNode
  translations: {
    title: string
    add: string
  } & DropzoneProps['translations']
} & ModifiedDropzoneProps

export const ChatDropzone = (props: ChatDropzoneProps) => (
  <Dropzone
    style={{ width: '100%' }}
    translations={props.translations}
    disabled={props.disabled}
    attachments={props.attachments}
    setAttachments={props.setAttachments}
    alreadyUploadedAttachments={props.alreadyUploadedAttachments}
    markAttachmentForDeletion={props.markAttachmentForDeletion}
  >
    {(open, isMobile) => (
      <>
        <InputFake
          value={props.children}
          suffix={
            <Flex style={{ pointerEvents: props.disabled ? 'none' : 'all' }}>{props.suffix}</Flex>
          }
          prefix={
            !isMobile ? (
              <Flex
                style={{ pointerEvents: props.disabled ? 'none' : 'all', alignItems: 'center' }}
              >
                <Button
                  type='text'
                  size='middle'
                  onClick={() => !props.disabled && open()}
                  icon={<UntitledIcon icon={usAttachment01} />}
                  label={props.translations.add}
                />

                <Space size={0}>{props.prefix}</Space>
              </Flex>
            ) : (
              <Flex style={{ pointerEvents: props.disabled ? 'none' : 'all' }}>{props.prefix}</Flex>
            )
          }
        />

        {isMobile && (
          <Form.Item label={props.translations.title} formItemProps={{ className: 'pt-4' }}>
            <Button onClick={open} size='middle' disabled={props.disabled}>
              <Space align='center'>
                <UntitledIcon icon={ucDropzone} className='flex text-base text-white' />
                {props.translations.add}
              </Space>
            </Button>
          </Form.Item>
        )}
      </>
    )}
  </Dropzone>
)
